export const TableHelpers = {
    data() {
        return {
            tableColumns : [
                {
                    title: this.$t('name'),
                    type: 'text',
                    key: 'fullname',
                    sortable: true,
                },


                {
                    title: this.$t('job'),
                    type: 'custom-html',
                    key: 'job',
                    sortable: true,
                    isVisible: true,
                    modifier: (value) => {
                        if (value) {
                            let ClassName = 'light-silver';
                            let available_jobs = '';

                            if(this.options.topBarFilters.find(o => o.key === 'filter-with-job')){
                                available_jobs = this.options.topBarFilters.find(o => o.key === 'filter-with-job');
                            } else {
                                available_jobs = this.options.filters.find(o => o.key === 'filter-with-job');
                            }


                            let index;
                            let a = [value];
                            let job_html = '';
                            for (index = 0; index < a.length; ++index) {
                                let selected_job = available_jobs.option.find(o => o.id === a[index]);

                                job_html += selected_job.value;

                            }

                            return '<div>'+job_html+'</div>';
                        }
                    }
                },

                {
                    title: this.$t('comments'),
                    type: 'custom-html',
                    key: 'comment',
                    modifier: (value) => {
                        let comment = "";
                        for (const property in value) {
                            if(property == "comment"){
                                comment = value[property];
                            }
                        }
                        if(comment){
                            return `<span v-else class="latest-comment">${comment}</span>`;
                        } else {
                            return `<span v-if="row[column.key].length === 0" class="fixed-row-height"><input type="button" value="+" class="btn btn-primary btn-sm " ></span>`;
                        }
                        
                    }
                },

                {
                    title: '★',
                    type: 'custom-html',
                    key: 'rating',
                    sortable: true,
                    isVisible: true,
                    modifier: (value) => {
                        if (value) {
                            let ClassName = 'rating';
                            let RatingText = '';
                            let RatingMissingText = '';

                            if (value == '0'){ ClassName = `rating-0`; RatingText = ` `;}
                            else if (value == '1'){ ClassName = `rating-1`; RatingText = `★`; RatingMissingText = `★★`;}
                            else if (value == '2'){ ClassName = `rating-2`; RatingText = `★★`; RatingMissingText = `★`;}
                            else if (value == '3'){ ClassName = `rating-3`; RatingText = `★★★`;}

                            return `<span class="rating-stars ${ClassName}">${RatingText}</span><span class="rating-stars rating-stars-inactive">${RatingMissingText}</span>`;
                        }
                    }
                },

                {
                    title: this.$t('tag'),
                    type: 'custom-html',
                    key: 'tag',
                    isVisible: true,
                    modifier: (value) => {
                        if (value) {
                            let ClassName = 'light-silver';

                            let available_tags = this.options.filters.find(o => o.key === 'filter-with-tag');

                            let index;
                            let a = JSON.parse(value);
                            let tag_html = '';
                            let tag_more_html = 0;
                            let tag_more_show = false;
                            for (index = 0; index < a.length; ++index) {

                                let selected_tag = available_tags.option.find(o => o.id === a[index]);
                                if(index < 3){
                                    tag_html += '<span class="badge badge-sm badge-pill badge-light-silver" title="'+selected_tag.value+'"><span class="chips-color" style="background-color: '+selected_tag.color+';"></span>'+selected_tag.value+'</span>';
                                } else {
                                    tag_more_html += 1;
                                    tag_more_show = true;
                                }



                            }

                            if(tag_more_show){
                                return '<div>'+tag_html+' <span class="badge badge-sm badge-pill">+'+tag_more_html+'</span></div>';
                            } else {
                                return '<div>'+tag_html+'</div>';
                            }

                        }
                    }
                },

                {
                    title: this.$t('skills'),
                    type: 'custom-html',
                    key: 'skill',
                    isVisible: false,
                    modifier: (value) => {
                        if (value) {
                            let ClassName = 'light-silver';

                            let available_skills = this.options.filters.find(o => o.key === 'filter-with-skill');

                            let index;
                            let a = JSON.parse(value);
                            let skill_html = '';
                            let skill_more_html = 0;
                            let skill_more_show = false;
                            for (index = 0; index < a.length; ++index) {

                                let selected_skill = available_skills.option.find(o => o.id === a[index]);
                                if(index < 3){
                                    skill_html += '<span class="badge badge-sm badge-pill badge-light-silver" title="'+selected_skill.value+'">'+selected_skill.value+'</span>';
                                } else {
                                    skill_more_html += 1;
                                    skill_more_show = true;
                                }

                            }

                            if(skill_more_show){
                                return '<div>'+skill_html+' <span class="badge badge-sm badge-pill">+'+skill_more_html+'</span></div>';
                            } else {
                                return '<div>'+skill_html+'</div>';
                            }
                        }
                    }
                },

                {
                    title: this.$t('phone'),
                    type: 'custom-html',
                    key: 'phone',
                    isVisible: true,
                    sortable: false,
                    tdClassName: 'd-xs-block d-sm-block d-md-none',
                    modifier: (value) => {
                        if (value) {
                            let phone_formatted = value.replace(/\s/g, "");

                            return `<a href="tel:${phone_formatted}" class="btn btn-success">${value}</a>`;
                        }
                    }
                },
                {
                    title: this.$t('residence'),
                    type: 'custom-html',
                    key: 'residence',
                    sortable: true,
                    isVisible: false,
                    modifier: (value) => {
                        if (value) {
                            let Residence = 'residence';
                            let RatingText = '';
                            let RatingMissingText = '';

                            // if (value == '1'){ Residence = '701';}
                            // else if (value == '2'){ Residence = '702';}
                            // else if (value == '3'){ Residence = '703';}
                            // else if (value == '4'){ Residence = '704';}
                            // else if (value == '5'){ Residence = '705';}
                            // else if (value == '6'){ Residence = '706';}
                            // else if (value == '7'){ Residence = '707';}
                            // else if (value == '8'){ Residence = '708';}
                            // else if (value == '9'){ Residence = '709';}

                            return value;
                            // return `${Residence}`;
                        }
                    }
                },
                {
                    title: this.$t('salary'),
                    type: 'custom-html',
                    key: 'salary',
                    isVisible: false,
                    sortable: true,
                    modifier: (value) => {
                        if (value) {
                            return `<span class="text-muted">${value} Kč</span>`;
                        }
                    }
                }, 
                {
                    title: this.$t('application_date'),
                    type: 'custom-html',
                    key: 'created_at',
                    isVisible: false,
                    sortable: true,
                    modifier: (value) => {
                        if (value) {
                            let formattedDate = "";
                            if(value){
                                formattedDate = moment(value).format('DD.MM. HH:mm');
                            }
                            return `<span class="text-muted">${formattedDate}</span>`;
                        }
                    },
                }, 
                {
                    title: this.$t('start_of_onboarding'),
                    type: 'custom-html',
                    key: 'event_date',
                    isVisible: true,
                    sortable: true,
                    modifier: (value) => {
                        if (value) {
                            let formattedDate = "";
                            if(value){
                                formattedDate = moment(value).format('DD.MM.YY HH:mm');
                            }
                            return `<span class="text-muted">${formattedDate}</span>`;
                        } else {
                            return `<span class="text-muted">${this.$t('no_date')}</span>`;
                        }
                    },
                }, 



            ],
            actionObj : {
                title: ' ',
                type: 'action',
            }
        }
    },
}
